import React, { useEffect, useMemo } from 'react';
import type { PageConfig } from 'c-config';
import { PostAuthRoutes } from 'c-routes';
import {
    FilterableEntityTable,
    FilterableEntityTableRendererType,
    generateColumn,
} from 'c-pagination';
import type { CampaignReporting } from 'c-entity-types';
import { PermissionName } from 'c-sdk';
import { summaryIcon } from 'c-main/icons';
import { FullPageEntityTableWrapper } from 'c-wrapper';
import ReactGA from 'react-ga';

const paginationTag = 'summary-config-list';

const columns = [
    generateColumn<CampaignReporting>({
        headerTitle: 'Modules.Admin.SummarySetup.table.idCol',
        field: 'id',
        entityName: 'CampaignReporting',
        orderable: true,
    }),
    generateColumn<CampaignReporting>({
        headerTitle: 'Modules.Admin.SummarySetup.table.nameCol',
        field: 'name',
        entityName: 'CampaignReporting',
        orderable: true,
    }),
    generateColumn<CampaignReporting>({
        headerTitle: 'Modules.Admin.SummarySetup.table.campaignTypeCol',
        field: 'campaign_type',
        entityName: 'CampaignReporting',
        orderable: true,
    }),
];

const textSearchCols = ['name'];

// Saved summaries only; the same table also holds dashboard and pca configurations.
const baseFilters = { 'filter.type': ['summary'] };

const SummarySetupPage = () => {
    useEffect(() => {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, []);

    return (
        <FullPageEntityTableWrapper title="Modules.Admin.SummarySetup.metaTitle">
            <FilterableEntityTable
                key={paginationTag}
                tag={paginationTag}
                columns={columns}
                baseEntityName="CampaignReporting"
                routeTemplate={PostAuthRoutes.Admin.EditSummaryConfig}
                textSearchColumns={textSearchCols}
                filters={useMemo(() => baseFilters, [])}
                rendererType={FilterableEntityTableRendererType.Contained}
            />
        </FullPageEntityTableWrapper>
    );
};

const setup: PageConfig = {
    id: 'SummarySetupPage',
    component: SummarySetupPage,
    systemSearch: {
        title: 'Modules.Admin.SummarySetup.metaTitle',
        description: 'Modules.Admin.SummarySetup.description',
        type: 'page',
        icon: summaryIcon,
        route: PostAuthRoutes.Admin.SummarySetup,
        saveAsRecentPage: true,
        breadcrumbs: [
            { label: 'Modules.Admin.Home.metaTitle', link: PostAuthRoutes.Admin.AdminHome },
        ],
        permissions: [PermissionName.UniledportalCampaign_reportingRead],
    },
};

export default setup;
